// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3GalI","footer":"ModalUpdate_footer__34ytH"};